import * as d3 from "d3";
import { curveMonotoneX } from "d3";
import { Data } from "./pricing-graph.types";

interface Props {
	data: Data[];
	xScale: d3.ScaleTime<number, number, never>;
	yScale: d3.ScaleLinear<number, number, never>;
	height: number;
	stopOffset?: number | null;
}

export const BackgroundUnderLinePlot = ({
	data,
	xScale,
	yScale,
	height,
	stopOffset,
}: Props) => {
	const area = d3
		.area<Data>()
		.x((d: Data) => xScale(d.date))
		.y0(height)
		.y1((d: Data) => yScale(d.value))
		.curve(curveMonotoneX);

	const targetX =
		stopOffset !== null && typeof stopOffset === "number" && !isNaN(stopOffset)
			? xScale(data[0]?.date) +
				(xScale(data[data.length - 1]?.date) - xScale(data[0]?.date)) *
					stopOffset
			: xScale(data[0]?.date);

	const gradientId = "bgGradient";
	const gradient = (
		<linearGradient id={gradientId} x1="0%" y1="0%" x2="0%" y2="100%">
			{/* Background Gradient = alta-light-green in tailwind */}
			<stop offset="0%" stopColor="rgba(64, 193, 172, 0.24)" />
			<stop offset="100%" stopColor="rgba(64, 193, 172, 0.04)" />
		</linearGradient>
	);

	// Calculate the actual width needed based on the scale's range
	const scaleRange = xScale.range();
	const clipWidth = Math.max(scaleRange[1] - targetX, 0);
	const clipPathId = "clipAfterTarget";
	const clipPath = (
		<clipPath id={clipPathId}>
			<rect x={targetX} y={0} width={clipWidth} height={height} />
		</clipPath>
	);

	return (
		<g>
			<defs>
				{gradient}
				{clipPath}
			</defs>
			<path
				fill={`url(#${gradientId})`}
				d={area(data) as string}
				clipPath={`url(#${clipPathId})`}
				style={{ pointerEvents: "none" }}
			/>
		</g>
	);
};
